<template>
  <b-container fluid>
    <b-row>
      <b-col md="12">
        <div class="iq-card p-3 row">
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <h4>
              <i class="fa-solid fa-message" aria-hidden="true" style="font-size: 21px; margin-right: 3px; color: var(--iq-primary);"></i>&nbsp;
              {{cvCardTitle}}
            </h4>
          </div>
          <div class="col-12 col-sm-6 col-md-6 col-lg-6">
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="chatbot_data_srcAdd">{{cvbtnUploadFile}}</b-button>
            <b-button class="right-align-sm mt-2 mb-1 mt-sm-0 ml-2" variant="primary" @click="goToLlm">{{cvbtnLlm}}</b-button>
          </div>
        </div>
        <div class="iq-card row p-3" v-if="userData.user_role == 'USERROLE11111' || userData.user_role == 'USERROLE11118' || userData.user_role == 'USERROLE11116'">
          <b-col md="10" class="mb-2 ">
            <!-- Frontend Search -->
            <!-- <b-col sm="4" md="4" lg="4" xl="4" class="mb-3">
              <b-form-input
                id="search"
                v-model="filter"
                type="search"
                :placeholder="cvSearchText"></b-form-input>
            </b-col>Frontend Search -->
            <!-- Backend Search -->
            <b-form-input class="form-control"
              @input="searchchatbot_data_srcWithParams"
              v-model="search_param"
              type="search"
              :placeholder="cvSearchText"></b-form-input>
          </b-col><!-- Backend Search -->
          <b-col class="col-12 col-md-2">
            <CsvDownload :propModuleFile="cvModuleFile" class="Download_button pt-2"/>
            <CsvUpload :propModulePrefix="cvModulePrefix" class="Download_button pt-2"/>
          </b-col>
        </div>
        <div class="iq-card row p-3">
          <b-col class="container_minheight" md="12" v-if="chatbot_data_srcObjList && chatbot_data_srcObjList.length > 0">
            <b-table
              hover
              responsive
              :items="chatbot_data_srcObjList"
              :fields="columns"
              :no-border-collapse="true"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :filter="filter"
              :filter-included-fields="filterOn"
              :current-page="currentBatchNo"
              :per-page="dataPerPage"
            >
            <template v-slot:cell(user_name)="data">
                {{data.item.user_name}}
                <small>
                  Id:&nbsp;{{ data.item.user_id }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy(data.item.user_id)"></i><br>
                  Email:&nbsp;{{ data.item.user_email }}&nbsp;&nbsp;<i class="fa-solid fa-copy pointer" title="Copy User Id" @click="doCopy(data.item.user_email)"></i>
                  <br><br>
                  <b-button title="Train asset" class="actionIcon ml-1 mr-1" @click="trainBot(data.item)" v-if="!data.item.editable"><i class="ri-git-repository-commits-fill font-size-20"></i></b-button>
                  <b-button title="Delete asset" class="actionIcon ml-1 mr-1" @click="showChatBotDataSrcDeleteDialog(data.item)"><i class="ri-delete-bin-line font-size-20 m-0"></i></b-button>
                  <b-button title="Traning file" class="actionIcon ml-1 mr-1" v-if="data.item.training_file_url" @click="openTrainingFile(data.item.training_file_url)"><i class="ri-arrow-down-fill font-size-20 m-0"></i></b-button>
                </small>
              </template>
              <template v-slot:cell(process_state)="data">
                {{ getProcessStateLabel(data.item.process_state) }}
              </template>
              <template v-slot:cell(created_on)="data">
                {{data.item.created_on | dateFormat}}
              </template>
            </b-table>
          </b-col>
          <b-col class="container_minheight" md="12" v-else>
            No data found
          </b-col>
            <b-col sm="12" md="7">
              <b-btn variant="primary" @click="loadMoreData" v-if="showLoadMoreBtn">Load More</b-btn>
            </b-col>
            <b-col sm="5" md="5">
              <b-pagination
                v-model="currentBatchNo"
                :total-rows="totalRows"
                :per-page="dataPerPage"
                align="fill"
                size="sm"
                class="my-0"
              ></b-pagination>
            </b-col>
        </div>
      </b-col>
    </b-row>

    <b-modal
      v-model="showModelChatBotDataSrcAdd"
      scrollable
      :title="cvAddModalHeader"
    >
      <ChatBotDataSrcAdd :propOpenedInModal="true" @emitCloseChatBotDataSrcAddModal="closeChatBotDataSrcAddModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="chatbot_data_srcAdd('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeChatBotDataSrcAddModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModelChatBotDataSrcEdit"
      scrollable
      :title="cvEditModalHeader"
    >
      <ChatBotDataSrcEdit :propOpenedInModal="true" :propChatBotDataSrcObj="chatbot_data_srcEditObj" @emitCloseChatBotDataSrcEditModal="closeChatBotDataSrcEditModal" />
      <template #modal-footer="">
        <b-button size="sm" class="pull-left" @click="chatbot_data_srcEdit('FULLPAGE')">
          {{cvbtnModalExpand}}
        </b-button>
        <b-button size="sm" @click="closeChatBotDataSrcEditModal()">
          {{cvbtnModalCancel}}
        </b-button>
      </template>
    </b-modal>

    <b-modal v-model="showModelChatBotDataSrcDelete" size="sm" title="Delete" ok-title="Delete" cancel-title="Cancel">
      <p>{{cvDelMessage}}</p>
      <template #modal-footer="">
        <!-- Emulate built in modal footer ok and cancel button actions -->
        <b-button size="sm" @click="showModelChatBotDataSrcDelete = false">
          {{cvbtnModalCancel}}
        </b-button>
        <b-button size="sm" variant="primary" @click="chatbot_data_srcDelete()">
          {{cvbtnModalDelOk}}
        </b-button>
      </template>
    </b-modal>

    <b-toast v-model="showToast" name="Toast" :variant="toastVariant" :title="toastTitle">
      <div v-html="toastMsg"></div>
    </b-toast>
  </b-container>
</template>
<script>
import { ChatBotDataSrcs } from "../../../FackApi/api/ChatBotDataSrc.js"
import ChatBotDataSrcAdd from "./ChatBotDataSrcAdd.vue"
import ChatBotDataSrcEdit from "./ChatBotDataSrcEdit"
import ApiResponse from "../../../Utils/apiResponse"
import { socialvue } from "../../../config/pluginInit.js"
import CsvUpload from "../../../components/Csv/CsvUpload.vue"
import CsvDownload from "../../../components/Csv/CsvDownload.vue"
import Utility from "../../../Utils/utility.js"

export default {
  name: "ChatBotDataSrcList",
  components: {
    ChatBotDataSrcAdd,
    ChatBotDataSrcEdit,
    CsvUpload,
    CsvDownload
  },
  data () {
    return {
      cvCardTitle: "Chat Bot Data Source",
      cvbtnUploadFile: "Upload Asset",
      cvbtnLlm: "LLM",
      cvbtnBulkUploadWebURL: "Web URL CSV",
      cvbtnWebURL: "Web URL",
      cvSearchText: "Type to Search",
      cvbtnModalDelOk: "Delete",
      cvDelMessage: "Are you sure?",
      cvEditModalHeader: "Edit ChatBotDataSrc",
      cvAddModalHeader: "Upload File",
      cvbtnModalCancel: "Cancel",
      cvbtnModalExpand: "Expand",
      showToast: false,
      toastMsg: null,
      toastVariant: "default",
      toastTitle: "ChatBotDataSrc",
      showModelChatBotDataSrcAdd: false,
      showModelChatBotDataSrcEdit: false,
      showModelChatBotDataSrcDelete: false,
      sortBy: "name",
      sortDesc: false,
      columns: [
        { label: "# ", key: "id", class: "text-left align-text-top w-100px", sortable: true },
        { label: "user name", key: "user_name", class: "text-left align-text-top w-300px", sortable: true },
        { label: "file type", key: "file_type", class: "text-left align-text-top w-125px", sortable: true },
        { label: "file name", key: "file_name", class: "text-left align-text-top text-break w-125px", sortable: true },
        { label: "file extension", key: "file_extension", class: "text-left align-text-top w-125px", sortable: true },
        { label: "data schema", key: "data_schema", class: "text-left align-text-top w-125px", sortable: true },
        { label: "process state", key: "process_state", class: "text-left align-text-top w-125px", sortable: true },
        { label: "url", key: "url", class: "text-left align-text-top text-break w-125px", sortable: true },
        { label: "replace keywords", key: "replace_keywords", class: "text-left align-text-top w-125px", sortable: true },
        { label: "training file path", key: "training_file_path", class: "text-left align-text-top text-break w-125px", sortable: true },
        { label: "Action ", key: "action", class: "text-left align-text-top w-125px", sortable: false }
      ],
      chatbot_data_srcObjList: [],
      chatbot_data_srcEditObj: null,
      filter: null,
      filterOn: [],
      totalRows: 1,
      currentPage: 1,
      perPage: 100,
      delObj: null,
      whereFilter: {},
      search_param: "",
      currentBatchNo: 1,
      dataPerPage: 25,
      showLoadMoreBtn: true,
      cvModulePrefix: "weburl",
      cvModuleFile: "web_url",
      doCopy: Utility.doCopy
    }
  },
  computed: {
    userData () {
      return this.$store.getters["User/userData"]
    }
  },
  async mounted () {
    socialvue.index()
    this.chatbot_data_srcList()
  },
  methods: {
    /**
     * searchchatbot_data_srcWithParams
     */
    async searchchatbot_data_srcWithParams () {
      if (this.whereFilter.search_param.length == 0) {
        this.showLoadMoreBtn = true
      }
      this.currentBatchNo = 1
      this.chatbot_data_srcList()
    },
    /**
     * loadMoreData
     */
    async loadMoreData () {
      this.currentBatchNo = this.currentBatchNo + 1
      this.chatbot_data_srcList(true)
    },
    /**
     * chatbot_data_srcList
     */
    async chatbot_data_srcList (loadViaLoadMore = false) {
      try {
        // setting data for pagination
        this.whereFilter.currentBatchNo = this.currentBatchNo
        this.whereFilter.dataPerPage = this.dataPerPage
        this.whereFilter.search_param = this.search_param

        let chatbotDataSrcListResp = await ChatBotDataSrcs.chatbot_data_srcList(this, this.whereFilter)
        if (chatbotDataSrcListResp.resp_status) {
          if (this.whereFilter.search_param.length >= 0 && !loadViaLoadMore) {
            this.chatbot_data_srcObjList = [ ...chatbotDataSrcListResp.resp_data.data ]
          }
          else {
            this.chatbot_data_srcObjList = [ ...this.chatbot_data_srcObjList, ...chatbotDataSrcListResp.resp_data.data ]
          }
          this.showLoadMoreBtn = true

          // Adding the serial numbers:
          this.chatbot_data_srcObjList.forEach((s, index) => { s.id = index + 1 })
          this.totalRows = this.chatbot_data_srcObjList.length
        }
        else {
          this.showLoadMoreBtn = false
          this.currentBatchNo = this.currentBatchNo - 1
          this.toastMsg = chatbotDataSrcListResp.resp_msg
          this.toastVariant = "danger"
          this.showToast = true
        }
      }
      catch (err) {
        console.error("Exception occurred at chatbot_data_srcList() and Exception:", err)
      }
    },
    /**
     * goToLlm
    */
    goToLlm () {
      this.$router.push("/chatbot_llm_list")
    },
    /**
     * chatbot_data_srcAdd
     */
    chatbot_data_srcAdd (type) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/chatbot_data_src_add")
        }
        else {
          this.showModelChatBotDataSrcAdd = true
        }
      }
      catch (err) {
        console.error("Exception occurred at chatbot_data_srcAdd() and Exception:", err.message)
      }
    },
    /**
     * chatbot_data_srcEdit
     */
    chatbot_data_srcEdit (type, item) {
      try {
        if (type === "FULLPAGE") {
          this.$router.push("/admin/chatbot_data_src_edit/" + this.chatbot_data_srcEditObj.cbds_id)
        }
        else {
          this.chatbot_data_srcEditObj = item
          this.showModelChatBotDataSrcEdit = true
        }
      }
      catch (err) {
        console.error("Exception occurred at chatbot_data_srcEdit() and Exception:", err.message)
      }
    },
    /**
     * showChatBotDataSrcDeleteDialog
     */
    showChatBotDataSrcDeleteDialog (item) {
      try {
        this.delObj = item
        this.showModelChatBotDataSrcDelete = true
      }
      catch (err) {
        console.error("Exception occurred at showChatBotDataSrcDeleteDialog() and Exception:", err.message)
      }
    },
    /**
     * chatbot_data_srcDelete
     */
    async chatbot_data_srcDelete () {
      try {
        let chatbotDataSrcrcDelResp = await ChatBotDataSrcs.chatbot_data_srcDelete(this, this.delObj.cbds_id)
        await ApiResponse.responseMessageDisplay(this, chatbotDataSrcrcDelResp)

        if (chatbotDataSrcrcDelResp && !chatbotDataSrcrcDelResp) {
          this.showModelChatBotDataSrcDelete = false
          return false
        }

        let index = this.chatbot_data_srcObjList.indexOf(this.delObj)
        this.chatbot_data_srcObjList.splice(index, 1)
        this.totalRows = this.totalRows - 1
        this.showModelChatBotDataSrcDelete = false
      }
      catch (err) {
        console.error("Exception occurred at chatbot_data_srcDelete() and Exception:", err.message)
      }
    },
    /**
     * closeChatBotDataSrcAddModal
     */
    closeChatBotDataSrcAddModal (chatbotDataSrcAddData) {
      try {
        if (chatbotDataSrcAddData.resp_status) {
          this.chatbot_data_srcList()
        }

        this.showModelChatBotDataSrcAdd = false
      }
      catch (err) {
        console.error("Exception occurred at closechatbot_data_srcAddModal() and Exception:", err.message)
      }
    },
    /**
     * closeChatBotDataSrcEditModal
     */
    closeChatBotDataSrcEditModal () {
      try {
        this.showModelChatBotDataSrcEdit = false
      }
      catch (err) {
        console.error("Exception occurred at closeChatBotDataSrcEditModal() and Exception:", err.message)
      }
    },
    /**
     * trainBot
     */
    async trainBot (dataSrcObj) {
      try {
        const trainResp = await ChatBotDataSrcs.chatbot_data_trainBot(this, dataSrcObj)
        await ApiResponse.responseMessageDisplay(this, trainResp)
      }
      catch (err) {
        console.error("Exception in trainBot and err: ", err)
      }
    },
    /**
     * getProcessStateLabel
     */
    getProcessStateLabel (state) {
      switch (state) {
        case 0:
          return "Process initiated for uploading the asset"
        case 1:
          return "File uploaded to chatbot successfully"
        case 2:
          return "Unreachable web page in case of URLs"
        case 99:
          return "Chatbot trained on the file"
        default:
          return "Unknown state"
      }
    },
    /**
     * getProcessStateLabel
     */
    openTrainingFile (url) {
      window.open(`${url}`, "_blank")
    }
  }
}
</script>
<style scoped>
.iq-card .card-title{
  display: block !important;
}
@media (min-width: 576px){
.body_div{
  padding-top: 30px;
  }
}
</style>
